import React, { useState } from "react";
import { FaPhone } from "react-icons/fa"; // call icon

import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";

const HelpSupport = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [page] = useState(1); 
  const phoneNumber = "+1234567890"; 

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area">
          <SubHeader />

          <iframe
            src={`/admin-crm-user-guide.pdf#page=${page}&toolbar=0&navpanes=0&scrollbar=0`}
            title="PDF Guide"
            width="100%"
            height="600px"
            style={{ border: "1px solid #eee", borderRadius: "6px" }}
          />

          <div style={{ marginTop: "12px", textAlign: "right" }}>
            <a
              href={`tel:${phoneNumber}`}
              style={{
                background: "#007BFF",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "8px 12px",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                textDecoration: "none",
              }}
            >
              <FaPhone /> Call Support
            </a>
          </div>
        </main>
      </div>
    </div>
  );
};

export default HelpSupport;